import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FieldWriteNumberComponent } from '../../field-write-number.component'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Animations } from '../../../../Animations';
import { from } from 'rxjs';
import * as settings from '../../../../common/settings';
import * as Units from '../../../../common/units';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-speed-field-w',
  templateUrl: './speed-field-w.component.html',
  styleUrls: ['./../../Field-Styles.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class SpeedFieldWComponent extends FieldWriteNumberComponent implements OnInit {
  @Input() public units: settings.DisplayUnits;
  unitsText: string = "";

  constructor(fb: FormBuilder, translateService: TranslateService) {
    super(fb, translateService);
    this.units = settings.userSettings.displayUnits;
    this.fixUnitsText();

    settings.userSettings.displayUnitsSub.subscribe(x => {
      this.changeUnits(x);
    });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.fixUnitsText();
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public getValue(): number {
    let val = super.getValue();
    if (this.units == settings.DisplayUnits.Imperial && val != undefined)
      return val * Units.KNOT_TO_METER_SEC;
    return val;
  }

  public changeUnitsClick() {
    this.changeUnits();
  }

  public changeUnits(units?: settings.DisplayUnits) {
    if (units != undefined)
      this.units = units;
    else
      this.units = settings.nextDisplayUnit(this.units);
    this.fixUnitsText();
    this.fixInputUnits();
  }

  public fixUnitsText() {
    switch (this.units) {
      case settings.DisplayUnits.Imperial:
        this.unitsText = this.translateService.instant("UNITS.KNOTS");
        if (this.Form)
          if (this.checkValValid(this.Form.controls.Field.value))
            this.Form.controls.Field.setValue((this.Form.controls.Field.value * Units.METER_SEC_TO_KNOT).toFixed(this.MaxNumsAfterDot));
        break;

      case settings.DisplayUnits.Metric:
        this.unitsText = this.translateService.instant("UNITS.MS");
        if (this.Form)
          if (this.checkValValid(this.Form.controls.Field.value))
            this.Form.controls.Field.setValue((this.Form.controls.Field.value * Units.KNOT_TO_METER_SEC).toFixed(this.MaxNumsAfterDot));
        break;

      default:
        break;
    }
  }

  public fixInputUnits() {
    switch (this.units) {
      case settings.DisplayUnits.Imperial:
        this.Validator = [Validators.required];
        if (this.MaxVal != undefined)
          this.Validator.push(Validators.max(this.MaxVal * Units.METER_SEC_TO_KNOT));
        if (this.MinVal != undefined)
          this.Validator.push(Validators.min(this.MinVal * Units.METER_SEC_TO_KNOT));
        break;

      case settings.DisplayUnits.Metric:
        this.Validator = [Validators.required];
        if (this.MaxVal != undefined)
          this.Validator.push(Validators.max(this.MaxVal));
        if (this.MinVal != undefined)
          this.Validator.push(Validators.min(this.MinVal));
        break;

      default:
        break;
    }

    let val = '';
    if (this.Form)
      val = this.Form.controls.Field.value;
    this.Form = this.fb.group({
      Field: [val, this.Validator],
    });
  }

  transVal(val: number): number {
    if (val == undefined)
      return undefined;
    return val * Units.METER_SEC_TO_KNOT;
  }
}
